import Flickity from 'flickity';

const FullWidthImageSlider = (slider) => {

    if (typeof slider != "undefined" && slider != null) {

        var carouselStatus = document.querySelector('.full-width-image-video__count');
        
        var flkty = new Flickity( slider, {
            adaptiveHeight: true,
            autoPlay: false,
            cellSelector: '.full-width-image-video__image',
            lazyLoad: false,
            pageDots: false,
            wrapAround: true,
        });

        function updateStatus() {
            var slideNumber = flkty.selectedIndex + 1;
            carouselStatus.textContent = slideNumber + ' / ' + flkty.slides.length;
        }
        updateStatus();

        flkty.on( 'select', updateStatus );
    }
}

export default FullWidthImageSlider;